import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import { Outlet, useLocation } from "react-router-dom";

export default function Layout() {
  const { pathname } = useLocation();
  const hideChat = pathname.startsWith("/admin");
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "#FDF9F1" }}>
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      {!hideChat && <ChatWidget />}
    </div>
  );
}
